export const environment = {
  production: true,
  appKey: 'Grip_FE_UAT',
  apiUrl: 'https://grip-stg.lan.pwc.com/API.Gateway/uat/api',
    applicationId: 3,
    auth: {
        authority: 'https://dev-247992.oktapreview.com/oauth2/default',
        client_id: '0oapcq3j53v5PFtyb0h7',
        redirect_uri: 'https://grip-stg.lan.pwc.com/uat/auth-callback',
        post_logout_redirect_uri: 'https://grip-stg.lan.pwc.com/uat/logout-callback',
      response_type: "code",
      scope: "openid profile email",
      filterProtocolClaims: true,
      loadUserInfo: false
    }
};
